import { type Procedure } from '@prisma/client'
import { Link } from 'react-router'
const ProcedureListElement = (props: { procedure: Procedure }) => {
	const { procedure } = props
	const quickInfo = JSON.parse(procedure.quickInfo || '{}')
	const purpose = quickInfo?.purpose
	return (
		<li
			key={procedure.id}
			className="prose relative bg-white px-4 py-5 focus-within:ring-2 focus-within:ring-inset hover:bg-gray-50"
		>
			<div className="flex justify-between space-x-3">
				<div className="min-w-0 flex-1">
					<Link
						to={procedure.slug}
						preventScrollReset
						prefetch="intent"
						className="block text-xl font-extrabold text-amber-700 focus:outline-none"
					>
						{procedure.name}
					</Link>
				</div>
				{/* <time
											dateTime={procedure.updatedAt}
											className="flex-shrink-0 whitespace-nowrap text-sm text-gray-500"
										>
											{procedure.formattedDate}
										</time> */}
			</div>
			{purpose && <p className="text-sm text-gray-500">{purpose}</p>}
		</li>
	)
}

export default ProcedureListElement
